import React from 'react';
import useNames from '../../hooks/useNames';
import { useTimeFormat } from '../../context/LocaleContext';
import { HOME_WORDING as W, agendaStatus, agendaTime } from '../../domain/home';
import s from './home.module.css';

// One lesson on today's agenda.
//
// The status and its `($)` are `agendaStatus` in src/domain/home.js. The `($)`
// is a claim about money, so it asks the lesson's billing and not the status
// table's (#362): an event carrying `This event requires a make-up credit`
// makes `Unrecorded` not billable, and today's agenda is mostly unrecorded
// lessons. Same question `AttendanceTab`'s option labels ask one screen away,
// and it has to give the same answer.
//
// The time is on the studio's Region's clock, as the calendar and the statement
// write it (#618): a US studio reads "3:30 PM – 45 min", not the stored
// "15:30". MMS's agenda writes the start and the end instead, "4:00 PM - 4:30
// PM"; ours keeps the duration.

export default function AgendaRow({ row, onEditAttendance }) {
  const names = useNames();
  const formatTime = useTimeFormat();
  const who = row.student ? names.student(row.student) : row.occurrence.categoryLabel;

  return (
    <div className={s.row}>
      <div className={s.time}>
        {agendaTime(formatTime(row.occurrence.startTime), row.occurrence.durationMin)}
      </div>
      <div className={s.who}>{who}</div>
      <span className={s.status}>
        {agendaStatus(row.status, row.occurrence?.requiresMakeupCredit)}
      </span>
      <button className={s.edit} onClick={onEditAttendance}>{W.editAttendance}</button>
    </div>
  );
}
